import React from 'react'
import CommentListItemHeader from './CommentListItemHeader'
import { Box, Flex, Text } from '@chakra-ui/react'
import PropTypes from 'prop-types'

export const CommentListItem = React.memo(
  ({ user, updated, commentText, index, commentId, parentId, ...rest }) => {
    return (
      <Flex
        flexDirection="column"
        data-parent-id={parentId}
        {...rest}
      >
        <CommentListItemHeader
          user={user}
          dateUpdated={updated}
          index={index}
          commentId={commentId}
        />
        <Box p="0px 16px 12px">
          <Text textStyle="comments">{commentText}</Text>
        </Box>
      </Flex>
    )
  },
)

CommentListItem.propTypes = {
  user: PropTypes.any,
  updated: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  commentText: PropTypes.string,
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  commentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  parentId: PropTypes.string,
}
